import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StatusSubscriptionState {
    subscribedUserIds: string[];
    subscriptionCounts: Record<string, number>;
}

const initialState: StatusSubscriptionState = {
    subscribedUserIds: [],
    subscriptionCounts: {}
};

const statusSubscriptionSlice = createSlice({
    name: 'statusSubscription',
    initialState,
    reducers: {
        subscribeToUserStatuses: (state, action: PayloadAction<string[]>) => {
            for (const id of action.payload) {
                const currentCount = state.subscriptionCounts[id] ?? 0;
                state.subscriptionCounts[id] = currentCount + 1;

                if (currentCount === 0) {
                    state.subscribedUserIds.push(id);
                }
            }
        },
        unsubscribeFromUserStatuses: (state, action: PayloadAction<string[]>) => {
            for (const id of action.payload) {
                const currentCount = state.subscriptionCounts[id] ?? 0;

                if (currentCount <= 1) {
                    delete state.subscriptionCounts[id];
                    state.subscribedUserIds = state.subscribedUserIds.filter(subscribedId => subscribedId !== id);
                } else {
                    state.subscriptionCounts[id] = currentCount - 1;
                }
            }
        },
        clearAllSubscriptions: (state) => {
            state.subscribedUserIds = [];
            state.subscriptionCounts = {};
        }
    }
});

export const {
    subscribeToUserStatuses,
    unsubscribeFromUserStatuses,
    clearAllSubscriptions
} = statusSubscriptionSlice.actions;

export const selectSubscribedUserIds = (state: { statusSubscription: StatusSubscriptionState }) =>
    state.statusSubscription.subscribedUserIds;

export default statusSubscriptionSlice.reducer;
